import { Link, NavLink } from 'react-router-dom';

import styles from './Sidebar.module.scss';
import { UserContext } from '../../contexts/UserContext';
import { useContext, useEffect, useState } from 'react';
import { ReactComponent as HomeIcon } from '../../assets/icons/home.svg';
import { ReactComponent as ProposalIcon } from '../../assets/icons/proposal.svg';
import { ReactComponent as OrderIcon } from '../../assets/icons/order.svg';
import { ReactComponent as ChatsIcon } from '../../assets/icons/chats.svg';
import { ReactComponent as ClaimIcon } from '../../assets/icons/claim.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { ReactComponent as BurgerIcon } from '../../assets/icons/burger.svg';
import { ReactComponent as UserIcon } from '../../assets/icons/user.svg';
import { ReactComponent as SupportIcon } from '../../assets/icons/support.svg';
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg';
import { useTranslation } from 'react-i18next';

export default function Sidebar() {
   const { config, deals, tickets, conversations } = useContext(UserContext);
   const [open, setOpen] = useState(false);

   const { t } = useTranslation('sidebar');

   useEffect(() => {
      setOpen(false);
   }, [window.location.pathname]);

   if (!config) return null;

   let logoUrl = `${process.env.PUBLIC_URL}/img/logos/${config.logo}`;
   if (config.logo.includes('http')) {
      logoUrl = config.logo;
   }

   const getDay = () => {
      const days = [
         'sunday',
         'monday',
         'tuesday',
         'wednesday',
         'thursday',
         'friday',
         'saturday',
      ];
      return days[new Date().getDay()];
   };

   return (
      <>
         <div className={styles.header}>
            <Link to='/'>
               <img src={logoUrl} alt={config.name} className={styles.logo} />
            </Link>

            <div className={styles.links}>
               <NavLink
                  className={styles.navitem}
                  to={`${config.storeUrl}/customer/account/index/`}
                  target='_blank'
               >
                  <UserIcon />
                  {t('profile')}
               </NavLink>
               <NavLink to={'/support'} className={styles.navitem}>
                  <SupportIcon />
                  {t('support')}
               </NavLink>
               <NavLink
                  className={`${styles.navitem} ${styles.hiddenMobile}`}
                  to={`${config.storeUrl}/customer/account/logout/`}
                  target='_blank'
               >
                  <LogoutIcon />
                  {t('logout')}
               </NavLink>

               <NavLink
                  className={`${styles.navitem} ${styles.hiddenDesktop}`}
                  to={`/claims`}
                  target='_blank'
               >
                  <ClaimIcon />
                  {t('tickets')}
               </NavLink>

               <button
                  className={`${styles.navitem} ${styles.burger}`}
                  type='button'
                  onClick={() => setOpen(!open)}
               >
                  {open ? <CloseIcon /> : <BurgerIcon />}
                  {t(open ? 'close' : 'menu')}
               </button>
            </div>
         </div>

         <div className={`${styles.sidebar} ${open ? styles.open : ''}`}>
            <nav className={styles.menu}>
               <NavLink
                  to={'/'}
                  className={({ isActive }) =>
                     `${styles.link} ${isActive ? styles.active : ''}`
                  }
               >
                  <HomeIcon />
                  {t('home')}
               </NavLink>

               <NavLink
                  to={'/proposals'}
                  className={({ isActive }) =>
                     `${styles.link} ${isActive ? styles.active : ''}`
                  }
               >
                  <ProposalIcon />
                  {t('proposals')}

                  {(deals?.proposalDeals.length || 0) > 0 && (
                     <span className={styles.count}>
                        {deals?.proposalDeals.length}
                     </span>
                  )}
               </NavLink>

               <NavLink
                  to={'/orders'}
                  className={({ isActive }) =>
                     `${styles.link} ${isActive ? styles.active : ''}`
                  }
               >
                  <OrderIcon />
                  {t('orders')}

                  {(deals?.orderDeals.length || 0) > 0 && (
                     <span className={styles.count}>
                        {deals?.orderDeals.length}
                     </span>
                  )}
               </NavLink>

               <NavLink
                  to={'/messages'}
                  className={({ isActive }) =>
                     `${styles.link} ${isActive ? styles.active : ''}`
                  }
               >
                  <ChatsIcon />
                  {t('contact')}

                  {(conversations?.conversationThreads.length || 0) > 0 && (
                     <span className={styles.count}>
                        {conversations?.conversationThreads.length}
                     </span>
                  )}
               </NavLink>

               <NavLink
                  to={'/claims'}
                  className={({ isActive }) =>
                     `${styles.link} ${isActive ? styles.active : ''} ${styles.hiddenMobile}`
                  }
               >
                  <ClaimIcon />
                  {t('tickets')}

                  {(tickets?.claimTickets.length || 0) > 0 && (
                     <span className={styles.count}>
                        {tickets?.claimTickets.length}
                     </span>
                  )}
               </NavLink>

               <NavLink
                  className={`${styles.link} ${styles.hiddenDesktop}`}
                  to={`${config.storeUrl}/customer/account/logout/`}
                  target='_blank'
               >
                  <LogoutIcon />
                  {t('logout')}
               </NavLink>
            </nav>

            <div className={styles.support}>
               {config.supportImage && (
                  <img
                     src={config.supportImage}
                     alt={config.name}
                     className={styles.supportImage}
                  />
               )}

               <strong>{t('contact_support')}</strong>

               {config.email && (
                  <a target='_blank' href={`mailto:${config.email}`}>
                     {config.email}
                  </a>
               )}
               {config.phone && (
                  <a target='_blank' href={`tel:${config.phone}`}>
                     {config.phone}
                  </a>
               )}

               <div className={styles.openingHours}>
                  <span className={styles.openNow} />
                  {t('phone_hours')}{' '}
                  {config.openingHours?.[getDay() as 'monday']}
               </div>
            </div>
         </div>
      </>
   );
}
